import React, { useEffect, useMemo } from "react";
import { SelectBox } from "devextreme-react";
import useResources from "../../hooks/useResources";
import useResourceStatus from "../../hooks/useResourceStatus";
import { useDispatch } from "react-redux";
import { getResourceAPI } from "../../redux/slices/resourceSlice";
import DataSource from "devextreme/data/data_source";
import { setUIProperty } from "../../redux/slices/uiSlice";

const CustomSelection = ({
  placeholder,
  disabled,
  value,
  resourceName,
  resourcePath,
  valueExpr,
  displayExpr,
  dataSource = [],
  handleChange = () => false,
}) => {
  const dispatch = useDispatch();

  const { [resourceName]: resourceData } = useResources();
  const { [`${resourcePath}Status`]: resourceStatus } = useResourceStatus();

  useEffect(() => {
    resourceStatus === "idle" &&
      resourcePath &&
      dispatch(getResourceAPI({ path: resourcePath }));
  }, [dispatch, resourceName, resourcePath, resourceStatus]);

  useEffect(() => {
    if (placeholder === "Currency")
      dispatch(setUIProperty({ name: "selectedCurrency", value }));
  }, [dispatch, placeholder, value]);

  const optimalDS = useMemo(
    () =>
      new DataSource({
        paginate: true,
        pageSize: 5,
        loadMode: "raw",
        load: () =>
          dataSource.length > 0
            ? dataSource
            : Object.values(resourceData || {}),
      }),
    [dataSource, resourceData]
  );

  return (
    <SelectBox
      inputAttr={{ autocomplete: "new" }}
      disabled={disabled}
      value={value}
      placeholder={placeholder}
      onValueChanged={(e) => {
        if (e.event) return handleChange(e, resourcePath);
      }}
      onSelectionChanged={(e) => {
        if(e.selectedItem.name){
          e.component.option("hint", e.selectedItem.name);  
        }
        else if(e.selectedItem.Name){
          e.component.option("hint", e.selectedItem.Name);  
        }        
      }}
      valueExpr={valueExpr || "name"}
      displayExpr={displayExpr || "name"}
      searchEnabled={true}
      dataSource={optimalDS}
      useItemTextAsTitle={true}
    />
  );
};

export default CustomSelection;
